import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

export const fError = (error: unknown): string => {
  if (error instanceof TypeError) {
    return Array.isArray(error.message) ? error.message[0] : error.message;
  }
  if (error instanceof AxiosError) {
    return Array.isArray(error.message) ? error.message[0] : error.message;
  }
  if (typeof error === 'string') {
    return error;
  }

  const err = (error as any)?.message;

  if (err) {
    if (Array.isArray(err)) {
      return err[0];
    }
    return err;
  }

  return 'unknown error instance';
};

export const toastError = (error: unknown) => {
  const errorMessage = customError(fError(error));
  enqueueSnackbar(errorMessage, { variant: 'error' });
};

const customError = (error: unknown) => {
  let errorMessage = fError(error);

  // custom error
  switch (true) {
    case errorMessage.includes('Insufficient product position quota'):
      errorMessage = 'ยังไม่มีรายการโควต้า';
      break;
    case errorMessage.includes('Insufficient product amount'):
      errorMessage = 'ปริมาณสินค้าไม่เพียงพอ';
      break;
    case errorMessage.includes('email must be an email'):
      errorMessage = 'โปรดกรอกอีเมลให้ถูกต้อง';
      break;
    case errorMessage.includes('Invalid or already used refCode'):
      errorMessage = 'รหัสเชิญไม่ถูกต้อง หรือถูกใช้ไปแล้ว';
      break;
    case errorMessage.includes('The email address is already in use by another account'):
      errorMessage = 'ที่อยู่อีเมลนี้ถูกใช้โดยบัญชีอื่นแล้ว';
      break;
    case errorMessage.includes('too-many-requests'):
      errorMessage = 'มีการส่งคำขอมากเกินไป, โปรดลองอีกครั้งภายหลัง';
      break;
    case errorMessage.includes('อีเมลหรือรหัสผ่านไม่ถูกต้อง'):
    case errorMessage.includes('auth/invalid-credential'):
      errorMessage = 'อีเมลหรือรหัสผ่านไม่ถูกต้อง';
      break;
    case errorMessage.includes('OTP ของคุณไม่ถูกต้อง'):
    case errorMessage.includes('OTP not found'):
      errorMessage = 'รหัส OTP ของคุณไม่ถูกต้อง';
      break;
    case errorMessage.includes('OTP ของคุณหมดอายุ'):
      errorMessage = 'รหัส OTP ของคุณหมดอายุแล้ว';
      break;
    case errorMessage.includes('ต้องระบุรหัสเชิญ'):
      errorMessage = 'กรุณากรอกรหัสเชิญ';
      break;
    case errorMessage.includes('Insufficient product position amount'):
      errorMessage = 'โควต้าของคุณไม่เพียงพอต่อการดำเนินรายการ';
      break;
    case errorMessage.includes('ไม่พบผู้ใช้ในระบบ'):
      errorMessage = 'ไม่พบบัญชีผู้ใช้ในระบบ';
      break;
    case errorMessage.includes('ระบบเติมเครดิตไม่เปิดใช้งาน'):
      errorMessage = 'ระบบเติมเงินไม่เปิดใช้งาน';
      break;
    case errorMessage.includes('Insufficient credit'):
      errorMessage = 'ยอดเงินไม่เพียงพอ';
      break;
    case errorMessage.includes('ระบบถอนเครดิตไม่เปิดใช้งาน'):
      errorMessage = 'ระบบถอนเงินไม่เปิดใช้งาน';
      break;
    case errorMessage.includes('ไม่พบอีเมลนี้ในระบบ'):
      errorMessage = 'ไม่พบผู้ใช้อีเมลนี้ในระบบ';
      break;
    case errorMessage.includes('ไม่พบไฟล์รูปภาพ'):
      break;
    case errorMessage.includes('Weight not match'):
      errorMessage = 'น้ำหนักทองรวม ไม่ตรงกับน้ำหนักทองที่ถอน';
      break;
    case errorMessage.includes('ระบบได้ปิดทำการสำหรับวันนี้แล้ว'):
      break;
    case errorMessage.includes('Unauthorized'):
      errorMessage = 'เกิดข้อผิดลพลาด, โปรดลองใหม่อีกครั้ง';
      break;
    case errorMessage.includes('refTxIds should not be empty'):
      errorMessage = 'กรุณาเลือกรายการตั๋วที่ต้องการอนุมัติ';
      break;
    case errorMessage.includes('กรุณายืนยันตัวตนก่อนทํารายการ'):
      errorMessage = 'ลูกค้ายังไม่ยืนยันตัวตน, ไม่สามารถทํารายการได้';
      break;
    case errorMessage.includes('บัญชีนี้ถูกระงับการใช้งาน'):
      errorMessage = 'บัญชีนี้ถูกระงับการใช้งาน';
      break;
    case errorMessage.includes('ขนาดทองไม่ตรงกับจำนวนทองที่ต้องการแลกเปลี่ยน'):
      errorMessage = 'ขนาดทองไม่ตรงกับจำนวนทองที่ต้องการแลกเปลี่ยน';
      break;
    default:
      // errorMessage = 'เกิดข้อผิดลพลาด, โปรดลองใหม่อีกครั้ง';
      break;
  }

  return errorMessage;
};
